import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, EmptyState, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useMatchWorkflowsForDocument } from 'app/domains/workflows/features/useMatchWorkflowsForDocument';
import { WorkflowType } from 'shared/domains/apollo/generated/types';
import { EvaluatingState } from './EvaluatingState';
import { SelectWorkflow } from './SelectWorkflow';
import { useApprovalWorkflow } from '../../../ApprovalWorkflowProvider';
export function WorkflowInitialState(props) {
    const { onSelectWorkflow } = props;
    const { documentId } = useApprovalWorkflow();
    const { matchedWorkflows, loading, error } = useMatchWorkflowsForDocument(documentId, WorkflowType.ApprovalRequirementCheck);
    if (loading) {
        return <EvaluatingState />;
    }
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please reload the page and try again',
                comment: 'Document approval check - workflow matching error',
            })}/>);
    }
    return (<EmptyState withAvatar icon={<Falcon icon="eye"/>} title={t({
            comment: 'Document approval check - Approval might be needed title',
            message: 'Approval might be needed',
        })} description={t({
            comment: 'Document approval check - Approval might be needed description',
            message: 'This document might need internal approval before sending for eSigning',
        })} actions={matchedWorkflows.length === 0 ? (<Typography $appearance="100" $fontSize="small">
            <Trans comment="Document approval check - No matching workflows found">
              No matching workflows found for this document
            </Trans>
          </Typography>) : (<SelectWorkflow matchedWorkflows={matchedWorkflows} onSelect={onSelectWorkflow}/>)}/>);
}
